import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getQueryKeys } from '../queries/queryKeys';

const onBindClient = async ({ values, tenantName }) => {
  return await request.put(
    `/HousingStock/bind_client`,
    values,
    `При изменении жильца ${tenantName} произошла ошибка`,
    'Error'
  );
};

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

const useBindClient = () => {
  const queryClient = useQueryClient();

  const { params } = useRouteMatch();

  const houseId = useMemo(() => getId(params.pageId), [params.pageId]);

  const mutation = useMutation(onBindClient, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(getQueryKeys.flatsGrid(houseId));
    },
  });

  return mutation;
};

export default useBindClient;
